import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { JiraOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { useUserContext } from "@/components/user-context";
import { wacToken } from "@/libraries/design/foundations";
import { FeatureExposed } from "@/utils/feature-exposed";

import { WelcomeBackHeading } from "../../components";

export const LoggedInJiraFreeManagedUser = () => {
    const {
        user: { name }
    } = useUserContext();

    return (
        <FeatureExposed
            experimentKey="jfind-1565-sign-up-flow-overlay"
            group="Test"
        >
            <JiraOverlayTemplate size="sm">
                <div css={containerCss}>
                    <h1 css={headerCss}>
                        <WelcomeBackHeading name={name} />
                    </h1>
                    <p css={subHeaderCss}>
                        <FormattedMessage
                            id="JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOff"
                            defaultMessage="Pick up where you left off in Jira."
                        />
                    </p>
                    <SiteActivation />
                </div>
            </JiraOverlayTemplate>
        </FeatureExposed>
    );
};

const containerCss = css({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
});

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const subHeaderCss = css({
    color: wacToken("color.primary.black"),
    marginBlockStart: 4,
    marginBlockEnd: 16,
    textAlign: "center"
});
